import { TextBox } from "./text-box";

export class PasswordField extends TextBox {
    public static SELECTOR: string = "[data-password-field]";

    constructor(containerElement: Element) {
        super(containerElement);
    }
}



// WEBPACK FOOTER //
// ../common/material/form/password-field.ts